import React, {Component} from 'react';
import {
    Page,
    Navbar,
    NavLeft,
    NavTitle,
    NavTitleLarge,
    NavRight,
    Link,
    Toolbar,
    Block,
    BlockTitle,
    List,
    ListItem,
    Row,
    Col,
    Button
} from 'framework7-react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../store/actions';

class SPMTenagaPenunjang extends Component {
    state = {
        error: null,
        routeParams:{
            foo:'bar'
        },
        spm_tenaga_penunjang: {
            rows: [],
            total: 0
        },
        spm_tenaga_penunjang_total: {
            total56: 0,
            total712: 0,
            total1315: 0,
            total1618: 0,
            total18: 0,
            totaltotal: 0
        }
    }


    formatAngka = (num) => {
        return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') : num;
    }

    componentDidMount = () => {
        
        for (var property in this.props.tabBar) {
            // console.log(this.state.tabBar[property]);
            this.props.tabBar[property] = false;
        }
        
        this.props.tabBar.kategori = true;
        
        this.props.setTabActive(this.props.tabBar);
        console.log(this.props.tabBar);

        this.props.getSPMTenagaPenunjang(this.state.routeParams).then((result)=>{
            this.setState({
                spm_tenaga_penunjang: this.props.spm_tenaga_penunjang
            },()=>{
                
            });
        });
    }

    render()
    {
        return (
            <Page name="SPMTenagaPenunjang" hideBarsOnScroll>
                <Navbar sliding={false} large backLink="Kembali">
                    <NavTitle sliding>Tenaga Penunjang (Form 1.3 F)</NavTitle>
                    <NavTitleLarge style={{background:'#F6BC31', color:'white'}}>Tenaga Penunjang (Form 1.3 F)</NavTitleLarge>
                </Navbar>
                <Block strong style={{
                    marginTop:'0px', 
                    paddingLeft:'0px', 
                    paddingRight:'0px', 
                    paddingTop:'0px', 
                    paddingBottom:'0px'
                }}>
                    <div className="data-table" style={{overflowY:'hidden'}}>
                        <table>
                            <thead style={{background:'#eeeeee'}}>
                                <tr>
                                    <th className="label-cell" rowSpan="2" style={{minWidth:'40px'}}>&nbsp;</th>
                                    <th className="label-cell" rowSpan="2" style={{minWidth:'120px', color:'#434343', fontSize:'15px'}}>Jenjang</th>
                                    <th className="label-cell" rowSpan="2" style={{minWidth:'120px', color:'#434343', fontSize:'15px'}}>Status</th>
                                    <th className="label-cell" style={{textAlign:'center', color:'#434343', fontSize:'15px'}} colSpan="3">Tenaga Penunjang PNS</th>
                                    <th className="label-cell" style={{textAlign:'center', color:'#434343', fontSize:'15px'}} colSpan="3">Tenaga Penunjang Non PNS</th>
                                    <th className="label-cell" rowSpan="2" style={{textAlign:'center', minWidth:'120px', color:'#434343', fontSize:'15px'}}>Total<br/>Tenaga<br/>Penunjang</th>
                                    <th className="label-cell" rowSpan="2" style={{textAlign:'center', minWidth:'120px', color:'#434343', fontSize:'15px'}}>Kebutuhan<br/>Tenaga<br/>Penunjang</th>
                                </tr>
                                <tr>
                                    <th className="label-cell" style={{textAlign:'center'}}>Belum<br/>SMA/Sederajat</th>
                                    <th className="label-cell" style={{textAlign:'center'}}>Sudah<br/>SMA/Sederajat</th>
                                    <th className="label-cell" style={{textAlign:'center'}}>Jumlah<br/>Tenaga Penunjang<br/>PNS</th>
                                    <th className="label-cell" style={{textAlign:'center'}}>Belum<br/>SMA/Sederajat</th>
                                    <th className="label-cell" style={{textAlign:'center'}}>Sudah<br/>SMA/Sederajat</th>
                                    <th className="label-cell" style={{textAlign:'center'}}>Jumlah<br/>Tenaga Penunjang<br/>Non PNS</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.state.loading ?
                            <>
                                {this.props.dummy_rows.rows.map((option)=>{
                                    return (
                                        <tr>
                                            <td className="label-cell skeleton-text skeleton-effect-blink">
                                                loremipsum
                                            </td>
                                            <td className="label-cell skeleton-text skeleton-effect-blink">lorenipsumlorenipsum</td>
                                            <td className="numeric-cell skeleton-text skeleton-effect-blink">lorenipsum</td>
                                            <td className="numeric-cell skeleton-text skeleton-effect-blink">lorenipsum</td>
                                            <td className="numeric-cell skeleton-text skeleton-effect-blink">lorenipsum</td>
                                            <td className="numeric-cell skeleton-text skeleton-effect-blink">lorenipsum</td>
                                            <td className="numeric-cell skeleton-text skeleton-effect-blink">lorenipsum</td>
                                            <td className="numeric-cell skeleton-text skeleton-effect-blink">lorenipsum</td>
                                            <td className="numeric-cell skeleton-text skeleton-effect-blink">lorenipsum</td>
                                        </tr>
                                    )
                                })}
                            </>
                            :
                            <>
                            {this.state.spm_tenaga_penunjang.rows.map((option)=>{

                                return (
                                    <tr key={option.kode_wilayah}>
                                        <td className="label-cell">
                                            &nbsp;
                                        </td>
                                        {/* <td className="label-cell">
                                            {option.nama}
                                        </td> */}
                                        {option.status_sekolah === 'Negeri' &&
                                        <td className="label-cell" rowSpan="2">
                                            {option.nama}
                                        </td>
                                        }
                                        <td className="label-cell">
                                            {option.status_sekolah}
                                        </td>
                                        <td className="numeric-cell">{this.formatAngka(parseInt(0))}</td>
                                        <td className="numeric-cell">{this.formatAngka(parseInt(0))}</td>
                                        <td className="numeric-cell">{this.formatAngka(parseInt(0))}</td>
                                        <td className="numeric-cell">{this.formatAngka(parseInt(0))}</td>
                                        <td className="numeric-cell">{this.formatAngka(parseInt(0))}</td>
                                        <td className="numeric-cell">{this.formatAngka(parseInt(0))}</td>
                                        <td className="numeric-cell">{this.formatAngka(parseInt(0))}</td>
                                        <td className="numeric-cell">{this.formatAngka(parseInt(0))}</td>
                                    </tr>
                                )
                            })}
                            </>
                            }
                            </tbody>
                        </table>
                        <div className="data-table-footer" style={{display:'block', height:'75px'}}>
                            <div className="data-table-pagination">
                                &nbsp;
                            </div>
                        </div>
                    </div>
                </Block>
            </Page>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      updateWindowDimension: Actions.updateWindowDimension,
      setLoading: Actions.setLoading,
      setTabActive: Actions.setTabActive,
      getSPMTenagaPenunjang: Actions.getSPMTenagaPenunjang
    }, dispatch);
}

function mapStateToProps({ App, Spm }) {
    return {
        window_dimension: App.window_dimension,
        loading: App.loading,
        tabBar: App.tabBar,
        spm_tenaga_penunjang: Spm.spm_tenaga_penunjang
    }
}

export default (connect(mapStateToProps, mapDispatchToProps)(SPMTenagaPenunjang));
